export default __webpack_public_path__ + "static/media/av.7d87c557.jpg";